/* DDA · Footer: i menu diventano accordion su mobile (il primo aperto di default) */
(function () {
  var mq = window.matchMedia('(max-width: 768px)');
  var FOOTER_MENUS = 'footer .menus, .shopify-section-group-footer-group .menus, [id*="__footer"] .menus';

  function footerMenus() {
    var out = [];
    [].forEach.call(document.querySelectorAll(FOOTER_MENUS), function (m) {
      if (out.indexOf(m) < 0) out.push(m);
    });
    return out;
  }

  function toggle(item, title, open) {
    item.classList.toggle('is-open', open);
    if (title.getAttribute('role') === 'button') title.setAttribute('aria-expanded', String(open));
  }

  function setup(menus, groupIndex) {
    var items = [].slice.call(menus.querySelectorAll('.menus__item'));
    items.forEach(function (item, i) {
      var title = item.querySelector('.menus__item-title');
      var panel = item.querySelector('.menu-container');
      if (!title || !panel) return;
      item.classList.add('dda-acc__item');

      if (!item.__ddaAcc) {
        item.__ddaAcc = true;
        item.classList.toggle('is-open', groupIndex === 0 && i === 0);
        if (!panel.id) panel.id = 'dda-acc-panel-' + groupIndex + '-' + i;
        title.addEventListener('click', function () {
          if (!mq.matches) return;
          toggle(item, title, !item.classList.contains('is-open'));
        });
        title.addEventListener('keydown', function (e) {
          if (!mq.matches) return;
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(item, title, !item.classList.contains('is-open')); }
        });
      }

      if (mq.matches) {
        title.setAttribute('role', 'button');
        title.setAttribute('tabindex', '0');
        title.setAttribute('aria-controls', panel.id);
        title.setAttribute('aria-expanded', String(item.classList.contains('is-open')));
      } else {
        title.removeAttribute('role');
        title.removeAttribute('tabindex');
        title.removeAttribute('aria-controls');
        title.removeAttribute('aria-expanded');
      }
    });
    menus.classList.add('dda-acc');
  }

  function apply() { footerMenus().forEach(setup); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  if (mq.addEventListener) mq.addEventListener('change', apply); else mq.addListener(apply);
  document.addEventListener('shopify:section:load', apply);
})();

/* DDA · Barra sticky prodotto (solo mobile): aggiunge il prezzo (poster + cornice scelta) dentro il pulsante.
   Il tema riscrive il contenuto del pulsante a ogni cambio formato: lo script lo rimette a posto ogni volta. */
(function () {
  var MONEY = /(\d{1,3}(?:\.\d{3})+|\d+),(\d{2})/g;
  function nums(txt) {
    var out = [], m;
    MONEY.lastIndex = 0;
    while ((m = MONEY.exec(txt || ''))) out.push(parseFloat(m[1].replace(/\./g, '') + '.' + m[2]));
    return out;
  }
  function fmt(n) { return '€' + n.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function labelOf(btn) {
    var t = btn.querySelector('.button-title');
    if (t) return t;
    var kids = btn.children;
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      if (k.tagName === 'SPAN' && !k.classList.contains('price-inside-button') && !k.classList.contains('product-form__buttons-icon') && !k.classList.contains('dda-sticky-price')) return k;
    }
    return null;
  }
  // Pulsante principale del tema ("€22,00 ... AGGIUNGI AL CARRELLO"): il prezzo dentro include la cornice scelta
  function syncMain() {
    var fr = document.querySelector('.dda-cornici__price');
    var f = nums(fr && fr.textContent);
    var extra = f.length ? f[0] : 0;
    var btns = document.querySelectorAll('.product-form__buttons .product-form__submit, .product-form__buttons [name="add"]');
    [].forEach.call(btns, function (btn) {
      if (btn.closest('.product-sticky-cart')) return;
      var pib = btn.querySelector('.price-inside-button');
      if (!pib) return;
      if (pib.getAttribute('data-dda-base') === null) {
        var n = nums(pib.textContent);
        if (!n.length) return;
        pib.setAttribute('data-dda-base', String(Math.min.apply(null, n)));
        pib.setAttribute('data-dda-orig', pib.innerHTML);
      }
      var base = parseFloat(pib.getAttribute('data-dda-base'));
      var want = extra > 0 ? fmt(base + extra) : null;
      if (want) {
        if (pib.textContent.trim() !== want) pib.textContent = want;
        pib.setAttribute('data-dda-mod', '1');
      } else if (pib.getAttribute('data-dda-mod') === '1') {
        pib.innerHTML = pib.getAttribute('data-dda-orig');
        pib.removeAttribute('data-dda-mod');
      }
    });
  }
  var queued = false;
  function sync() {
    queued = false;
    syncMain();
    var bar = document.querySelector('.product-sticky-cart');
    if (!bar) return;
    var btn = bar.querySelector('.product-form__submit') || bar.querySelector('[name="add"]');
    if (!btn) return;
    var span = btn.querySelector('.dda-sticky-price');
    var mobile = window.matchMedia('(max-width: 768px)').matches;
    var soldOut = btn.hasAttribute('disabled') || btn.hasAttribute('data-sold-out') || btn.getAttribute('aria-disabled') === 'true';
    var label = labelOf(btn);
    var priceEl = bar.querySelector('.sticky-cart__content .price');
    var p = nums(priceEl && priceEl.textContent);
    if (!p.length) { var pib = btn.querySelector('.price-inside-button'); p = nums(pib && pib.textContent); }
    if (!mobile || soldOut || !p.length || !label) { if (span) span.remove(); return; }
    var base = Math.min.apply(null, p);
    var fr = document.querySelector('.dda-cornici__price');
    var f = nums(fr && fr.textContent);
    var text = '– ' + fmt(base + (f.length ? f[0] : 0));
    if (!span) { span = document.createElement('span'); span.className = 'dda-sticky-price'; label.after(span); }
    else if (span.previousElementSibling !== label) { label.after(span); }
    if (span.textContent !== text) span.textContent = text;
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(sync); } }
  function init() {
    var bar = document.querySelector('.product-sticky-cart');
    if (bar) new MutationObserver(queue).observe(bar, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'data-sold-out'] });
    var fr = document.querySelector('.dda-cornici');
    if (fr) new MutationObserver(queue).observe(fr, { childList: true, subtree: true, characterData: true });
    [].forEach.call(document.querySelectorAll('.product-form__buttons'), function (b) { if (!b.closest('.product-sticky-cart')) new MutationObserver(queue).observe(b, { childList: true, subtree: true, characterData: true }); });
    document.addEventListener('variant:change', function () { setTimeout(queue, 200); setTimeout(queue, 800); });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.dda-cornici__opt')) { setTimeout(queue, 50); setTimeout(queue, 400); } });
    setInterval(queue, 600);
    queue();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* DDA · Flyout "Sconto primo ordine": il modulo iscrive a Klaviyo (invece di creare un cliente Shopify).
   Per cambiare lista modifica LIST_ID qui sotto. COMPANY_ID è la Public API key di Klaviyo (6 caratteri). */
(function () {
  var COMPANY_ID = 'SPBYKJ';
  var LIST_ID = 'XdVPaP';
  var SOURCE = 'Flyout · sconto primo ordine';

  function note(form, text, isError) {
    var n = form.parentNode.querySelector('.dda-nl-msg');
    if (!n) {
      n = document.createElement('p');
      n.className = 'dda-nl-msg';
      n.setAttribute('role', 'status');
      n.style.margin = '12px 0 0';
      form.after(n);
    }
    n.textContent = text;
    n.style.color = isError ? '#ffd6d6' : 'inherit';
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form.promo-popup-newsletter-form')) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var input = form.querySelector('input[type="email"]');
    var check = form.querySelector('input[type="checkbox"]');
    var btn = form.querySelector('button[type="submit"]');
    var email = input ? input.value.trim() : '';

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { note(form, 'Controlla l\'indirizzo email.', true); if (input) input.focus(); return; }
    if (check && check.required && !check.checked) { note(form, 'Per continuare serve il tuo consenso.', true); check.focus(); return; }
    if (!COMPANY_ID || !LIST_ID || LIST_ID.indexOf('INCOLLA') === 0) { note(form, 'Il modulo non è ancora collegato a Klaviyo.', true); console.error('Flyout Klaviyo: manca LIST_ID'); return; }

    if (btn) btn.disabled = true;
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(COMPANY_ID), {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'revision': '2026-07-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: SOURCE,
        profile: { data: { type: 'profile', attributes: {
          email: email,
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
          properties: { fonte: 'flyout-sconto-primo-ordine' }
        } } }
      }, relationships: { list: { data: { type: 'list', id: LIST_ID } } } } })
    }).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { console.error('Klaviyo ha risposto', r.status, t); throw new Error(r.status); });
      form.hidden = true;
      note(form, 'Grazie, sei iscritto!', false);
    }).catch(function (err) {
      console.error('Iscrizione non riuscita', err);
      if (btn) btn.disabled = false;
      note(form, 'Qualcosa non ha funzionato. Riprova tra poco.', true);
    });
  }, true);
})();

/* DDA · Linguetta blu del flyout ("SCONTO BENVENUTO"): compare solo dopo aver scorso la pagina.
   Per cambiare il punto di comparsa modifica TAB_AT (0.25 = 25% della pagina). */
(function () {
  var TAB_AT = 0.25;
  var root = document.documentElement;
  if (window.Shopify && Shopify.designMode) { root.classList.add('dda-tab-on'); return; }
  function check() {
    var max = Math.max(1, root.scrollHeight - window.innerHeight);
    if ((window.scrollY || window.pageYOffset || 0) / max >= TAB_AT) {
      root.classList.add('dda-tab-on');
      window.removeEventListener('scroll', check);
    }
  }
  window.addEventListener('scroll', check, { passive: true });
  check();
})();

/* DDA · Footer: la voce di menu con indirizzo "#preferenze-cookie" apre le preferenze cookie di Iubenda. */
(function () {
  function bind() {
    [].forEach.call(document.querySelectorAll('a[href$="#preferenze-cookie"]'), function (a) {
      if (a.getAttribute('data-dda-cookie')) return;
      a.setAttribute('data-dda-cookie', '1');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        if (window._iub && _iub.cs && _iub.cs.api && typeof _iub.cs.api.openPreferences === 'function') _iub.cs.api.openPreferences();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  setTimeout(bind, 1500);
})();

/* DDA · Flyout newsletter: niente hCaptcha. Il modulo non viene inviato a Shopify ma a Klaviyo, quindi lo anti-spam di Shopify
   (la "manina" con "Protetto da hCaptcha") non serve: l'attributo data-nocaptcha gli dice di ignorare questo modulo. */
(function () {
  function mark() {
    [].forEach.call(document.querySelectorAll('form.promo-popup-newsletter-form'), function (f) {
      f.setAttribute('data-nocaptcha', 'true');
    });
  }
  mark();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark);
  document.addEventListener('shopify:section:load', mark);
  setTimeout(mark, 1000);
})();

/* DDA · Barra fissa "Aggiungi al carrello" (solo mobile): visibile subito in basso; quando arriva al punto in cui sta il
   pulsante in pagina si nasconde (resta quello in pagina, che scorre con la pagina); quando il pulsante in pagina esce
   dallo schermo verso l'alto, la barra riappare dal basso. */
(function () {
  var mq = window.matchMedia('(max-width: 768px)');
  var BOTTOM_PAD = 16; // distanza della pillola fissa dal bordo inferiore (vedi CSS)
  var queued = false;
  function inpageButton() {
    var list = document.querySelectorAll('.product-form__buttons .product-form__submit, .product-form__buttons [name="add"]');
    for (var i = 0; i < list.length; i++) {
      if (!list[i].closest('.product-sticky-cart') && list[i].offsetParent !== null) return list[i];
    }
    return null;
  }
  function update() {
    queued = false;
    var docked = false;
    if (mq.matches && document.querySelector('.product-sticky-cart')) {
      var b = inpageButton();
      if (b) {
        var r = b.getBoundingClientRect();
        var fixedTop = window.innerHeight - BOTTOM_PAD - r.height;
        docked = r.height > 0 && r.bottom > 0 && r.top <= fixedTop + 1;
      }
    }
    var on = mq.matches && !!document.querySelector('.product-sticky-cart') && !!inpageButton();
    if (document.body.classList.contains('dda-pill-on') !== on) document.body.classList.toggle('dda-pill-on', on);
    if (document.body.classList.contains('dda-docked') !== docked) document.body.classList.toggle('dda-docked', docked);
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(update); } }
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('touchmove', update, { passive: true });
  if (window.visualViewport) { window.visualViewport.addEventListener('scroll', update); window.visualViewport.addEventListener('resize', update); }
  window.addEventListener('resize', queue);
  window.addEventListener('orientationchange', queue);
  window.addEventListener('load', queue);
  document.addEventListener('variant:change', function () { setTimeout(queue, 200); });
  setInterval(queue, 500);
  queue();
})();
